import { atom, useAtomValue, useSetAtom } from 'jotai';

export interface CompanyRaw {
  id: number;
  industry: string;
  latest_activity_date: string;
  name: string;
  num_active_projects: number;
  num_completed_projects: number;
  num_total_projects: number;
  avg_project_cost: number | null;
  latest_document_type: string | null;
  latest_document_status: string | null;
  uuid: string;
  city_codes: string[][];
  website: string;
}

const selectedCompanies = atom<CompanyRaw[]>([]);

export const useCompanies = () => {
  const selectedCompaniesList = useAtomValue(selectedCompanies);
  const updateSelectedCompanies = useSetAtom(selectedCompanies);

  return {
    selectedCompaniesList,
    updateSelectedCompanies,
  };
};
